import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import dateHelper from '@utils/dates';
import { Spacings, mobile, Fonts } from '../../../styleConstants';
import SectionDescription from './SectionDescription';

const DateWrapper = styled(SectionDescription)`
  margin-top: ${Spacings.SPACING_8B};
  color: #1f2432;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    margin-top: ${Spacings.SPACING_4B};
    font-size: ${Fonts.H4};
  }
`;

const DateDelimeter = styled.span`
  color: #7b8ab5;
`;

const delimeters = [' • ', ' - '];

const SummitDate = ({ className }) => {
  const dates = useSelector(({ summit }) =>
    (summit.schedule || []).map((daySchedule) => daySchedule.date)
  );
  return dates.length > 0 ? (
    <DateWrapper className={className}>
      {dateHelper.getMonthString(dates[0])}
      &nbsp;
      {dates.map((date, index, srcArray) => (
        <>
          {dateHelper.getDay(date)}
          <DateDelimeter>
            {index === srcArray.length - 1 ? delimeters[1] : delimeters[0]}
          </DateDelimeter>
        </>
      ))}
      {dateHelper.getYear(dates[dates.length - 1])}
    </DateWrapper>
  ) : null;
};

SummitDate.propTypes = {
  className: PropTypes.string
};

SummitDate.defaultProps = {
  className: ''
};

export default SummitDate;
